import React from 'react';
import { Box, Button, Typography, Container, Link, Alert } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Loading from '../Common/Loading';

const SignUpPage = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  // Auth0 signup
  const handleAuth0Signup = () => {
    loginWithRedirect({
      screen_hint: 'signup',
    });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Create Your Account
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Join InkedUpManager to start managing your tattoo business
        </Typography>
        
        {/* Auth0 Sign Up Button */}
        <Button
          variant="contained"
          color="primary"
          sx={{ 
            mt: 2, 
            mb: 3, 
            py: 1.5, 
            width: '100%',
            backgroundColor: '#635BFF',
            '&:hover': {
              backgroundColor: '#4F46E5',
            },
          }}
          onClick={handleAuth0Signup}
        >
          Sign Up with Auth0
        </Button>
        
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography variant="body2">
            Already have an account? <Link href="/signin" style={{ color: '#635BFF' }}>Sign In</Link>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <Link href="/forgotpassword" style={{ color: '#635BFF' }}>Forgot Password?</Link>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default SignUpPage;